import Vue from 'vue'

function updateGlobalVar(state,{name,data}){
	if(name == 'areas'){
		try{
			let areas = []
			data.forEach(item=>{
    			if(item.level === 1){
    				areas.push({
    					value: item.area_id,
    					label: item.name,
    					children: []
    				})
    			}
    			if(item.level === 2){
    				let parea = areas.find(child=>child.value === item.parent_id)
    				if(parea && parea.children){
    					parea.children.push({
    						value: item.area_id,
	    					label: item.name,
	    					children: []
    					})
    				}          				            										
    			}
    			if(item.level === 3){  
    				let parent = data.find(di=>di.area_id === item.parent_id)
    				let top    = areas.find(ci=>ci.value === parent.parent_id)  
    				let top_children = top.children.find(si=>si.value === item.parent_id) 
    				if(top_children && top_children.children){
    					top_children.children.push({
    						value: item.area_id,
    						label: item.name
    					})
    				}						
    			}            			
    		})
    		Vue.set(state.gvars,name,areas)
    	}catch(e){
    	}
    }else{	
		Vue.set(state.gvars,name,data)
	}
}

export default {
	setLayout(state,vm){
		state.layout = vm
	},
	setLoginInfo(state,data){
		state.client = data.client
		state.user.info = data
		state.user.token = data.token
		state.user.login_time = Math.floor((new Date()).getTime()/1000)
		state.user.login_server_time = data.login_server_time
		state.user.expire_time = data.expired

		Vue.localStorage.set('vipuser',JSON.stringify(state.user))
		Vue.http.headers.common['x-token'] = data.token
	},
	setClientInitPaied(state){
		state.client.is_init_pay = 1
		state.user.info.client.is_init_pay = 1
		Vue.localStorage.set('vipuser',JSON.stringify(state.user))
	},
	addClientExpiredYear(state,year){
		state.client.expire_day = parseInt(state.client.expire_day) + 10000 * year
		state.user.info.client.expire_day = state.client.expire_day
		Vue.localStorage.set('vipuser',JSON.stringify(state.user))
	},
	addClientAccountLimitNum(state,nums){
		state.client.account_num_limit = state.client.account_num_limit + nums
		state.user.info.client.account_num_limit = state.client.account_num_limit
		Vue.localStorage.set('vipuser',JSON.stringify(state.user))
	},
	addClientStudentLimitNum(state,nums){
		state.client.student_num_limit = state.client.student_num_limit + nums
		state.user.info.client.student_num_limit = state.client.student_num_limit
		Vue.localStorage.set('vipuser',JSON.stringify(state.user))
	},
	setClient(state,data){
		state.client = data
	},
	setGlobalVars(state,globals){
		for(let o in globals){
			updateGlobalVar(state,{name:o,data:globals[o]})
		}
		Vue.localStorage.set('gvars',JSON.stringify(state.gvars))
	},
	clearLoginInfo(state){
		state.user.info = null
		state.user.login_time  = 0
		state.user.login_server_time = 0
		state.user.expire_time = 0
		state.user.token = ''
		Vue.localStorage.remove('vipuser')
		delete Vue.http.headers.common['x-token']
	},
	updateLoginExpire(state){
		state.user.login_time = Math.floor((new Date()).getTime()/1000)
		Vue.localStorage.set('vipuser',JSON.stringify(state.user))
	},
	updateUserInfo(state,{user,action}){
		switch(action) {
			case 'changeName':
				state.user.info.name = user.name
				break
			case 'changeAvatar':
				state.user.info.avatar = user.avatar
				break
			case 'bind_mobile':
				state.user.info.mobile = user.mobile
				state.user.info.is_mobile_bind = 1
				break
			case 'bind_email':
				state.user.info.email = user.email
				state.user.info.is_email_bind = 1
				break
			case 'bind_wx':
				state.user.info.is_weixin_bind = 1
				state.user.info.openid = user.openid
				break
			case 'unbind_wx':			
				state.user.info.is_weixin_bind = 0
				state.user.info.openid = ''
				break
		}
		Vue.localStorage.set('vipuser',JSON.stringify(state.user))
	},
	setWxToken(state,{openid}){
		state.user.openid = openid
		Vue.localStorage.set('vipuser',JSON.stringify(state.user))
	},
	updateGlobalVar,
	updateDictList(state,{name,data}){
		Vue.set(state.dicts,name,data)
	},
	buildIdTextMap(state,{list,name,ifield,tfield}){
		let name_object = name+'_object'
		let map = state.maps[name]||{},
			map_object = state.maps[name_object]||{}
		list.forEach(item=>{
			map[item[ifield]] = item[tfield]
			map_object[item[ifield]] = item
		})
		Vue.set(state.maps,name,map)
		Vue.set(state.maps,name_object,map_object)
	},
	updateIdTextMap(state,{item,name,ifield,tfield}){
		let name_object = name+'_object'
		let map = state.maps[name]||{},
			map_object = state.maps[name_object]||{}
		map[item[ifield]] = item[tfield]
		map_object[item[ifield]] = item
		Vue.set(state.maps,name,map)
		Vue.set(state.maps,name_object,map_object) 
	},
	setCache(state,{key,val}){
		Vue.set(state.cache,key,val)
	},
	httpRequestStart(state,url){
		state.http.request = url
		state.http.response = ''
	},
	httpRequestEnd(state,url){
		state.http.response = url
		if(url == state.http.request){
			state.http.request = ''
		}
	},
	httpSavingStart(state,{url,method}){
		state.http.saving = true
	},
	httpSavingEnd(state,{url,method}){
		state.http.saving = false
	}
}


// WEBPACK FOOTER //
// ./src/store/mutations.js